import React,{useEffect,useState,useRef} from "react";
import "./Dashboard.css";

import { get_dashboard_data } from "services/master.service";
import PaymentModeRevenueChart from "./PaymentModeRevenueChart";
import CustomLogoLoader from "../../../components/CustomLogoLoader";


const Dashboard = () => {

  const [dashboardData, setDashboardData] = useState(null);
  // const [showChart, setShowChart] = useState(false);
  const [reportType, setReportType] = useState("days"); // "days" | "months"
  const [monthRange, setMonthRange] = useState(6);
  // const [reportType, setReportType] = useState("days");
  const [range, setRange] = useState(7);
  const [open, setOpen] = useState(false);


  
  // const trafficData = [
  //   { label: "Direct Traffic", value: 40 },
  //   { label: "Organic Search", value: 30 },
  //   { label: "Social Media", value: 15 },
  //   { label: "Referral Traffic", value: 10 },
  //   { label: "Email Campaigns", value: 5 },
  // ];

  // const getTrafficClass = (value) => {
  //   if (value >= 30) return "high";
  //   if (value >= 15) return "medium";
  //   return "low";
  // };


  // const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);

  // const options = ["Stock", "Order", "Customer"]; // dropdown items
  // const wrapperRef = useRef(null);

  // Close dropdown if clicked outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
  //       setDropdownOpen(false);
  //     }
  //   }
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [wrapperRef]);

  // const handleSelect = (item) => {
  //   setSelectedItem(item);
  //   setDropdownOpen(false);
  // };



  // Dashboard Data Fetch
  useEffect(() => {
    const fetchDashboard = async () => {
      const data = await get_dashboard_data(reportType,range);
      // const total = data.total_sales.total;
      setDashboardData(data);
      console.log(data)
      
    };

    fetchDashboard();
  }, [reportType,range]);

  // Total Sales Box
  const salesChange = dashboardData?.total_sales?.change || 0;

  //Order
  const totalOrders = dashboardData?.total_orders?.total?.toLocaleString() || 0;
  const orderChange = dashboardData?.total_orders?.change || 0 ;

  // Revenue Analysis Box
  const revenueData = dashboardData?.revenue_data?.data || []

  // Counter-Wise Sales Summary 
  const counterSalesData = {
    counter_sales: Array.isArray(dashboardData?.counter_sales?.counter_sales)
      ? dashboardData.counter_sales.counter_sales
      : [],
    total_counter_sales: dashboardData?.counter_sales?.total_counter_sales || 0 , 
  };

  // Conversion Rate Box
  const cart = dashboardData?.conversion_data?.add_cart_count || 0;
  const abandoned_cart = dashboardData?.conversion_data?.abandoned_cart_count || 0;
  const completed_orders = dashboardData?.conversion_data?.completed_orders || 0;
  const checkout = dashboardData?.conversion_data?.checkout || 0;
  const cancelled = dashboardData?.conversion_data?.cancelled_orders || 0;

  const conversionData = [
    { label: "Add to Cart", value: cart },
    { label: "Placed Orders", value: checkout },
    { label: "Completed Purchase", value: completed_orders },
    { label: "Cancelled Purchase", value: cancelled },
    { label: "Abandoned Carts", value: abandoned_cart },
  ];

  const maxValue = Math.max(...conversionData.map(i => i.value));

  // Recent Orders 
  const latest_orders = dashboardData?.recent_orders?.orders || [];

  // Recent Activity
  const activityList = dashboardData?.recent_activity?.activity_list || []

  if (!dashboardData) {
    return (
      <div 
        style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          minHeight: "75vh",
          width: "100%"
        }}
      >
        <CustomLogoLoader />
      </div>
    );
  }

  return (
    <div className="dashboard">

      {/* HEADER */}
      <div className="dashboard-header">
        <h2>Dashboard</h2>
        {/* <div className="search-dropdown" ref={wrapperRef}>
          <input
            className="search-input"
            placeholder="Search stock, order, etc"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            readOnly
          />
        </div> */}
      </div>

      {/* MAIN GRID */}
      {/* ================= MAIN GRID (ROW 1 + ROW 2 ONLY) ================= */}
      <div className="dashboard-grid">

        {/* ROW 1 – SMALL STATS */}
        {/* Total Sales Card  */}
        <div className="stat-card highlight horizontal">
        <p className="title">Total Sales</p>

        <div className="stat-row">
          <div className="stat-item">
            <small>Online</small>
            <h3>
              ₹
              {dashboardData?.total_sales?.online?.toLocaleString() || "0"}
            </h3>
          </div>

          <div className="stat-item">
            <small>Offline</small>
            <h3>
              ₹
              {dashboardData?.total_sales?.offline?.toLocaleString() || "0"}
            </h3>
          </div>

          <span className={salesChange >= 0 ? "positive" : "negative"}>
            {salesChange >= 0 ? "▲" : "▼"} {Math.abs(salesChange)}%
          </span>
        </div>
      </div>


        {/* Total Orders Card  */}
        <div className="stat-card">
          <p>Total Orders</p>
          <div className="order-row"> 
            <h3 className="orders-count">{totalOrders}</h3>
          {/* <span className="negative">-2.89%</span> */}
          <span className={orderChange >= 0 ? "positive" : "negative"}>
            {orderChange >= 0 ? "▲" : "▼"} {Math.abs(orderChange)}%
          </span>
          </div>
        </div>
      
      {/* Total Visitors Card  */}
      <div className="stat-card horizontal">
        <p className="title">Visitors</p>

        <div className="stat-row">
          <div className="stat-item">
            <small>Total</small>
            <h3>
              {dashboardData?.total_visitors?.total_data?.total_visitors?.toLocaleString()}
            </h3>
          </div>

          <div className="stat-item">
            <small>Active</small>
            <h3>
              {dashboardData?.total_visitors?.total_data?.active_visitors?.toLocaleString()}
            </h3>
          </div>

          <span className="positive">
            {(() => {
              const total =
                dashboardData?.total_visitors?.total_data?.total_visitors || 0;
              const active =
                dashboardData?.total_visitors?.total_data?.active_visitors || 0;

              if (!total) return "0%";

              return `${((active / total) * 100).toFixed(2)}%`;
            })()}
          </span>
        </div>
      </div>


        {/* TOP CATEGORIES – ONLY ROW 1 + ROW 2 */}
        <div className="card top-categories">
          <h4>Top 5 Categories</h4>

          {(() => {
            const categories = dashboardData?.category_sales?.data || [];
            const topCategories = categories.slice(0, 5);

            const radius = 55;
            const circumference = 2 * Math.PI * radius;

            const COLORS = [
              "#51ff91", // Green
              "#4d85fe", // Blue
              "#ff9c55", // Orange
              "#af59ff", // Purple
              "#ff4e4e", // Red
            ];


            const totalSales = topCategories.reduce(
              (sum, item) => sum + item.total_sales,
              0
            );

            let offset = 0;

            return (
              <>
                <div className="donut">
                  <svg viewBox="0 0 120 120" className="donut-svg">
                    <g transform="rotate(-90 60 60)">
                      {topCategories.map((item, index) => {
                        const dash =
                          (item.total_sales / totalSales) * circumference;
                        const currentOffset = offset;
                        offset += dash;

                        return (
                          <circle
                            className="donut-segment"
                            key={item.category_id}
                            cx="60"
                            cy="60"
                            r={radius}
                            stroke={COLORS[index]}
                            strokeWidth="10"
                            fill="none"
                            strokeDasharray={`${dash} ${circumference}`}
                            strokeDashoffset={-currentOffset}
                            strokeLinecap="round"
                          />
                        );
                      })}
                    </g>
                  </svg>

                  <div className="donut-center">
                    <small>Total Amount</small>
                    <h3>₹{totalSales.toLocaleString()}</h3>
                    
                  </div>
                </div>

                <ul className="category-list">
                  {topCategories.map((item, index) => (
                    <li key={item.category_id}>
                      <span
                        className="dot"
                        style={{ backgroundColor: COLORS[index] }}
                      ></span>
                      {item.category}
                      <span> ₹{item.total_sales.toLocaleString()}</span>
                    </li>
                  ))}
                </ul>
              </>
            );
          })()}
      </div>


        {/* ROW 2 */}
        {/* 🔁 SWAPPED: Recent Orders Table moved here */}
        <div className="card revenue">
          <div className="row4-header">
            <h4>Recent Orders</h4>
          </div>

          <div className="orders-table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Product</th>
                <th>Qty</th>
                <th>Total</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {latest_orders.map((order, index) => {
                const firstItem = order.items[0]; // first product
                const productDisplay =
                  order.items.length > 1
                    ? `${firstItem.product_name} ..etc`
                    : firstItem.product_name;

                return (
                  <tr key={order.order_id}>
                    <td>{index + 1}</td>
                    <td>{order.order_id}</td>
                    <td>{order.customer_name}</td>
                    <td>{productDisplay}</td>
                    <td>{order.quantity}</td>
                    <td>{order.price}</td>
                    <td>
                      <span className={`status ${order.order_status.toLowerCase()}`}>
                        {order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1)}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>

      </div>


      {/* ================= ROW 3 – SEPARATE GRID ================= */}
      <div className="dashboard-row3">
        
        {/* Counter Wise Sales Summary Card  */}
        <div className="card counter-card">
          <h4>Counter-wise Sales Summary</h4>

          <div className="counter-top">
            <div className="counter-total">
              <small className="counter-total-label">Total Sales</small>
              <h3>₹{counterSalesData.total_counter_sales.toLocaleString()}</h3>
            </div>
          </div>

          <small className="counter-sub">Last 30 Days Counter Sales</small>

          <div className="counter-list">
            {counterSalesData.counter_sales.map((item) => {
              const percentage =
                (item.total_sales / counterSalesData.total_counter_sales) * 100;

              return (
                <div key={item.counter_id} className="counter-item">
                  <div className="counter-label">
                    <span>{item.counter_name}</span>

                    <span className="counter-value">
                      ₹{item.total_sales.toLocaleString()} ({percentage.toFixed(1)}%)
                    </span>
                  </div>

                  <div className="counter-bar">
                    <span style={{ width: `${percentage}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Conversion Rate Card */}
        <div className="card row3-wide">
          <h4>Conversion Rate</h4>

          <div className="conversion-bars">
            {conversionData.map((item, index) => {
              const height = (item.value / maxValue) * 100;

              return (
                <div key={index} className="conversion-bar-item">
                  <div className="bar-wrapper">
                    <div
                      className="bar-fill"
                      style={{ height: `${height}%` }}
                    ></div>
                  </div>

                  <p className="bar-value">{item.value.toLocaleString()}</p>
                  <span className="bar-label">{item.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Delivery Status Card */}
        <div className="card">
          <h4>Delivery Status</h4>
          {(() => {
          const delivered = dashboardData?.delivery_status?.delivered || 0;
          const cancelled = dashboardData?.delivery_status?.cancelled || 0;
          const others =    dashboardData?.delivery_status?.others || 0;
          const totalOrders = dashboardData?.total_orders?.total || 0 ;

          const radius = 50;
          const circumference = Math.PI * radius; // semi-circle
          const strokeWidth = 10;

          const segments = [
            { label: "Delivered", value: delivered, color: "#16a34a" },
            { label: "Cancelled", value: cancelled, color: "#dc2626" },
            { label: "Other Status", value: others, color: "#3226dc" },
            
          ];

          let offset = 0;

          return (
            <>
              <div className="target-ring">
                <svg viewBox="0 0 120 60" width="120" height="50">
                  <g transform="rotate(0 60 50)">
                    
                    {/* 🔹 Background semi-circle */}
                    <path
                      d="M10 50 A50 50 0 0 1 110 50"
                      stroke="#86efac"   // light gray background
                      strokeWidth={strokeWidth + 10}
                      fill="none"
                      strokeLinecap="round"
                    />

                    {/* 🔹 Foreground segments */}
                    {totalOrders && segments.filter(segment => segment.value > 0).map((segment) => {
                      const dash = (segment.value / totalOrders) * circumference;
                      const currentOffset = offset;
                      offset += dash;

                      return (
                        <path
                          key={segment.label}
                          d="M10 50 A50 50 0 0 1 110 50"
                          stroke={segment.color}
                          strokeWidth={strokeWidth + 5}
                          fill="none"
                          strokeDasharray={`${dash} ${circumference}`}
                          strokeDashoffset={-currentOffset}
                          strokeLinecap="round"
                        />
                      );
                    })}
                  </g>
                </svg>

                <div className="ring-center">
                  <h2>{totalOrders}</h2>
                  <h3>Total Orders</h3>
                </div>
              </div>


              <ul className="ring-legend">
                {segments.map((segment) => (
                  <li key={segment.label}>
                    <span
                      className="dot"
                      style={{ backgroundColor: segment.color }}
                    ></span>
                    {segment.label}: {segment.value} (
                    {Math.round((segment.value / (totalOrders )) * 100) || 0}%)
                  </li>
                ))}
              </ul>
            </>
          );
        })()}
        </div>
      </div>


      {/* ================= ROW 4 ================= */}
      <div className="dashboard-row4">

        {/* 🔁 SWAPPED: Revenue Analytics Graph moved here */}
        <div className="card row4-left">
          <div className="card-header">
            <h4>Revenue Analytics</h4>

          <div className="revenue-filter">
              <div className="custom-select">
                <div className="selected" onClick={() => setOpen(!open)}>
                  {reportType === "days" ? "Days" : "Months"}
                </div>

                {open && (
                  <div className="options">
                    <div onClick={() =>{ 
                      setReportType("days");
                      setRange(7);
                      setOpen(false)
                      }}>
                        Days
                    </div>
                    <div onClick={() => {
                      setReportType("months");
                      setRange(1);
                      setOpen(false)
                      }}>
                        Months
                    </div>
                  </div>
                )}
              </div>


              <input
                className="revenue-input"
                type="number"
                min={1}
                value={range}
                onChange={(e) => setRange(Number(e.target.value))}
                placeholder={`Enter ${reportType}`}
              />
            </div>

            <p>
              Last {range} {reportType === "days" ? range > 1 ?"Days" : "Day" : range > 1 ? "Months" : "Month"} Report
            </p>

          </div>

          <div className="chart-placeholder">
            <PaymentModeRevenueChart
              data={revenueData}
              reportType={reportType}
            />
          </div>
        </div>

        {/* Recent Activity */}
        <div className="card row4-right">
          <h4>Recent Activity</h4>

          <ul className="activity-list">
            {activityList.length === 0 && <li>No recent activity</li>}

            {activityList.map((activity, index) => (
              <li key={index} className={`${activity.type}`}>
                <span className={`dot ${activity.type || "default"}`}></span>

                {activity.type === "order" && activity.order_id && activity.order_status && (
                  <>
                    Order #{activity.order_id} status changed to{" "}
                    <strong>
                      {activity.order_status.charAt(0).toUpperCase() +
                        activity.order_status.slice(1)}
                    </strong>
                  </>
                )}

                {activity.type === "review" && (
                  <>
                    {activity.user_name} left a <strong>{activity.star}-star review</strong>
                  </>
                )}

                {activity.type === "feedback" && (
                  <>
                    {activity.user_name} submitted feedback: "{activity.description}"
                  </>
                )}

                {activity.type === "price_update" && (
                  <>
                    Price updated for <strong>{activity.product_name}</strong>{" "}
                    from ₹{activity.old_price} → ₹{activity.new_price}
                  </>
                )}

                <small>{activity.time}</small>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
